import { Component, ViewEncapsulation } from '@angular/core';
import { UIBlockingService } from '../core/ui-blocking.service';
import { ToastNotificationService } from '../core/toast-notification.service';
import { DumbResourcePage } from './DTOs/dumb-resource-page';
import { Observable } from 'rxjs';
import { ResourceListDtRetInfo } from './DTOs/resource-list-dt-ret-info';
import { GetResourceListRequest } from './DTOs/get-resource-list-request';
import { SuperAdminResourcesService } from './super-admin-resources.service';

@Component({
  selector: 'app-resources-list',
    templateUrl: './resources-list.component.html',
  providers: [UIBlockingService],
  encapsulation: ViewEncapsulation.None
})
export class ResourcesListComponent {
    constructor(private resourcesService: SuperAdminResourcesService, private blockUI: UIBlockingService, private notificationService: ToastNotificationService) {

    }
    resources: DumbResourcePage[] = [];
    totalResources = 0;
    filteredResources = 0;
    pageNum = 1;
    itemsPerPage = 10;
    searchText = "";
    statusSearch = { display: "Active", value: 1 };
    sortType = 1;
    keywordSearches: string[] = [];
    filtersChanged = true;
    initialLoad = true;

    get currentPageNum() { return this.pageNum };
    set currentPageNum(page: number) {
        this.pageNum = page;
        this.getResourcePages();
    }
    get itemStart() {
        return ((this.currentPageNum - 1) * this.itemsPerPage) + 1;
    }
    get itemEnd() {
        return ((this.currentPageNum - 1) * this.itemsPerPage) + this.resources.length;
    }

    ngOnInit() {
        this.getResourcePages();
    }

    getResourcePages() {
        this.blockUI.start();
        this.getResourcesObservable()
            .subscribe(
                {
                    next: (data) => {
                        this.resources = data.data;
                        this.totalResources = data.recordsTotal;
                        this.filteredResources = data.recordsFiltered;
                    },
                    error: (err) => {
                        this.notificationService.error(err.error.message);
                        this.blockUI.stop();
                        console.log(err)
                    },
                    complete: () => {
                        this.blockUI.stop();
                        if (this.resources.length == 0) {
                            console.log(" no resources found ")
                        }
                    }
                });
    }

    getResourcesObservable(): Observable<ResourceListDtRetInfo> {
        var req = this.createSearchRequest();
        return this.
            resourcesService.getResourcesList(req);
    }

    createSearchRequest(): GetResourceListRequest {
        var req = new GetResourceListRequest();

        if (this.filtersChanged)
            this.pageNum = 1;

        req.PageNumber = this.pageNum - 1; //to get the 0-indexed number
        req.ItemsPerPage = this.itemsPerPage;

        req.KeywordSearches = this.keywordSearches;
        req.Sorting = this.sortType;

        req.StatusSearch = this.statusSearch.value;

        this.filtersChanged = false;

        return req;
    }

    enterSearchTerm(event: any) {
        if (event.keyCode != 13)//13 is enter, 32 is space
            return;

        this.searchText.trim().split(' ').forEach((term) => this.keywordSearches.push(term));
        this.searchText = '';
        this.filtersChanged = true;
        this.getResourcePages();
        return;
    }

    removeSearchTerm(term: string) {
        var index = this.keywordSearches.indexOf(term);
        if (index != -1) {
            this.keywordSearches.splice(index, 1);
            this.filtersChanged = true;
        }
        this.getResourcePages();
    }

    clearSearch() {
        this.searchText = "";
        this.statusSearch = { display: "Active", value: 1 };
        this.sortType = 1;
        this.keywordSearches = [];
        this.filtersChanged = true;
        this.getResourcePages();
    }
    hitSearchBtn() {
        this.searchText.trim().split(' ').forEach((term) => this.keywordSearches.push(term));
        this.searchText = '';
        this.filtersChanged = true;
        this.getResourcePages();
    }
    changeSortType(column: number) {
        switch (column) {
            case 1:
                if (this.sortType == 1)
                    this.sortType = 2;
                else this.sortType = 1;
                break;
            case 2:
                if (this.sortType == 3)
                    this.sortType = 4;
                else this.sortType = 3;
                break;
            case 3:
                if (this.sortType == 5)
                    this.sortType = 6;
                else this.sortType = 5;
                break;
            default:
                break;
        }
        this.filtersChanged = true;
        this.getResourcePages();
    }
    changeStatusSearch(toChange: number) {
        if (this.statusSearch.value == toChange)
            return;

        this.filtersChanged = true;
        switch (toChange) {
            case -1:
                this.statusSearch = { display: "Active", value: 1 };
                break;
            case 1:
                this.statusSearch = { display: "Deactivated", value: 2 };
                break;
            default:
                this.statusSearch = { display: "Active", value: 1 };
                break;
        }
        this.getResourcePages();
    }

}
